import React from 'react'
import T from 'prop-types'
import cx from 'classnames'
import { DropTarget } from 'react-dnd'
import ScrollBars from '../scrollbars/ScrollBars'
import Item from './Item'

const DND_ID = 'sortable_dnd_id'

class SortableItemList extends React.Component {
  static displayName = 'SortableMenu.Container'

  static propTypes = {
    connectDropTarget: T.func.isRequired,
    defaultItemIds: T.arrayOf(T.string), // Ordered array of IDs
    findItem: T.func.isRequired,
    items: T.arrayOf(
      T.shape({
        id: T.string.isRequired,
        display: T.string.isRequired
      })
    ), // Array of all possible array options
    listId: T.string.isRequired,
    moveItem: T.func.isRequired,
    onSortUpdated: T.func,
    touchBackendEnabled: T.bool // If true, will insert manual ItemPreview component on drag
  }

  static defaultProps = {
    allItems: [],
    defaultItemIds: []
  }

  render() {
    const { items, findItem, moveItem, listId, connectDropTarget } = this.props
    let content = (
      <div
        className={cx('sortable_menu_list', {
          inactive_list: listId === 'inactive'
        })}
      >
        <h4>
          {listId}
        </h4>
        <ScrollBars>
          {items.map((opt, i) => {
            return (
              <Item
                display={opt.display}
                findItem={findItem}
                id={opt.id}
                index={i}
                key={opt.id}
                moveItem={moveItem}
              />
            )
          })}
        </ScrollBars>
      </div>
    )
    content = connectDropTarget(content)
    return content
  }
}

const containerItemTarget = {
  hover(props, monitor) {
    // FIXME Disabled for TouchBackend until this bug with {shallow: true} is patched:
    // https://github.com/yahoo/react-dnd-touch-backend/issues/14
    if (props.touchBackendEnabled) return

    // If no list item has handled the hover, move to end of target list
    if (monitor.isOver({ shallow: true })) {
      const { listId, items, moveItem } = props
      const { id } = monitor.getItem()
      moveItem(id, items.length, listId === 'active')
    }
  }
}

export default DropTarget(DND_ID, containerItemTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))(SortableItemList)
